// Tiny blur on navigations & submits
(function () {
  const html = document.documentElement;

  function ensureOverlay() {
    if (!document.getElementById('ui-blur-overlay')) {
      const d = document.createElement('div');
      d.id = 'ui-blur-overlay';
      document.body.appendChild(d);
    }
  }
  function show() { ensureOverlay(); html.classList.add('is-transitioning'); }
  function hide() { html.classList.remove('is-transitioning'); }

  // Links
  document.addEventListener('click', function (e) {
    const a = e.target.closest('a');
    if (!a) return;

    const href = a.getAttribute('href') || '';
    if (href.startsWith('#') || a.target === '_blank' || href.startsWith('javascript:')) return;

    let url;
    try {
      url = new URL(a.href, window.location.href);
      if (url.origin !== window.location.origin) return;
    } catch { return; }

    e.preventDefault();
    show();

    requestAnimationFrame(function () {
      setTimeout(function () {
        window.location.href = url.href;
      }, 80);
    });

    setTimeout(hide, 4000);
  }, true);

  // Formulare
  document.addEventListener('submit', function () {
    show();
    setTimeout(hide, 4000);
  }, true);

  // Zurück/Vor & wenn Seite wieder sichtbar
  window.addEventListener('pageshow', hide);
  window.addEventListener('popstate', hide);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') hide();
  });
})();

